import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Subscription} from 'rxjs/Subscription';
import {EmissionService} from 'services/emission.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-water',
    templateUrl: './water.component.html',
    styleUrls: ['./water.component.css']
})
export class WaterComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmited = false;
    private defaultIntValue = 1;

    public form: FormGroup;

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmited = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    private createForm() {
        this.form = this.fb.group({
            bottles: [this.defaultIntValue, [Validators.required, CustomValidators.min(0),
                CustomValidators.max(999999999999), CustomValidators.digits]]
        });
    }

    private next() {
        let calculatorName = Constants.calculators.events;
        let categoryName = Constants.categories.events.water;
        let params = {
            bottles: this.getFV('bottles')
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            response => {
                let input = response.body[0].input[0];
                this.emissionService.setEmission({
                    category: categoryName,
                    emission: {
                        emission: input.emmission,
                        emissionTrees: input.emissionTrees,
                        DollarAmt: input.DollarAmt,
                        DollarAmtMonthly: input.DollarAmtMonthly
                    }
                });

                this.footerService.skip();
                this.spinner.hide();
            }
        );
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmited || this.form.get(param).touched);
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/events-calculator/water/water.component.ts